import {
  Directive,
  EventEmitter,
  HostListener,
  Inject,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { getScreenSize } from '../directives.utils';

@Directive({
  selector: `
   [flResponsiveClick],
  `,
})
export class ClickDirective {
  @Output() flClickMobile = new EventEmitter<Event | MouseEvent | TouchEvent>();
  @Output() flClickTablet = new EventEmitter<Event | MouseEvent | TouchEvent>();
  @Output() flClickDesktop = new EventEmitter<
    Event | MouseEvent | TouchEvent
  >();

  @Output() flTouchStartMobile = new EventEmitter<TouchEvent>();
  @Output() flTouchStartTablet = new EventEmitter<TouchEvent>();
  @Output() flTouchStartDesktop = new EventEmitter<TouchEvent>();

  @Output() flTouchEndMobile = new EventEmitter<TouchEvent>();
  @Output() flTouchEndTablet = new EventEmitter<TouchEvent>();
  @Output() flTouchEndDesktop = new EventEmitter<TouchEvent>();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @HostListener('click', ['$event'])
  onClick(event: Event | MouseEvent | TouchEvent): void {
    switch (getScreenSize(this.platformId)) {
      case 'desktop':
        this.flClickDesktop.emit(event);
        break;
      case 'tablet':
        this.flClickTablet.emit(event);
        break;
      case 'mobile':
        this.flClickMobile.emit(event);
        break;
      default:
        break;
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    switch (getScreenSize(this.platformId)) {
      case 'desktop':
        this.flTouchStartDesktop.emit(event);
        break;
      case 'tablet':
        this.flTouchStartTablet.emit(event);
        break;
      case 'mobile':
        this.flTouchStartMobile.emit(event);
        break;
      default:
        break;
    }
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent): void {
    switch (getScreenSize(this.platformId)) {
      case 'desktop':
        this.flTouchEndDesktop.emit(event);
        break;
      case 'tablet':
        this.flTouchEndTablet.emit(event);
        break;
      case 'mobile':
        this.flTouchEndMobile.emit(event);
        break;
      default:
        break;
    }
  }
}
